
import { Options, Vue } from "vue-class-component";
import SectionTotalTicket from "@/app/ui/views/dex-assessment/dashboard/components/section-total-ticket.vue";
@Options({
  components: {
    SectionTotalTicket
  }
})
export default class SectionSttDex extends Vue {}
